// extracted by mini-css-extract-plugin
export default {"header":"Header_header__Gim5a","title":"Header_title__M1-FU","headerButton":"Header_headerButton__NZuQ8"};